import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const UnusedMedications = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceUnusedMedicationsReset',
      isReset: true,
      buttonText: 'Reset All Unused Medications Data',
      features: [
        'Remove All Unused Medications Data'
      ]
    },
    {
      demo: 'practiceUnusedMedicationsDemo',
      isReset: false,
      buttonText: 'Prepare Unused Medications Section for a Demo',
      features: [
        'Scenario for Demo'
      ]
    }
  ]

  return (
    <DemoCard headerText='Unused Medications' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default UnusedMedications